import { render } from "./phoneComponent.vue?vue&type=template&id=1e06d6d4&scoped=true"
import script from "./phoneComponent.vue?vue&type=script&lang=js"
export * from "./phoneComponent.vue?vue&type=script&lang=js"

import "./phoneComponent.vue?vue&type=style&index=0&id=1e06d6d4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e06d6d4"]])

export default __exports__